import analytics from './analytics';
import quote from './quote';
import attachmentsMenu from './attachmentsMenu';
import feedback from './feedback';
import dialog from './dialog';
import currencyPay from './currencyPay';
import fortis from './fortis';
import signPdf from './signPdf';
import paymentTerms from './paymentTerms';
import error from './error';

const models = {
  analytics,
  dialog,
  quote,
  attachmentsMenu,
  feedback,
  currencyPay,
  fortis,
  signPdf,
  paymentTerms,
  error
};
export default models;
